import React from "react";
import styled from "styled-components";
import { device } from "../../../../utils/breakPoints";

/**
 * HTML card with product info
 *
 * @param {Object}  product  Product for card
 * @param {string}  img      Image to be used in card
 * @param {string}  href     Link for product
 *
 * @returns {Object}
 */
export default function Card({ product, img, href }) {
  // Get price in correct format
  const getPrice = () => {
    const price = product.price / 100;
    return "$" + price.toFixed(2);
  }

  return (
    <CardContainer>
      <CardInnerContainer>
        <ImageContainer>
          <Image src={img}></Image>
        </ImageContainer>
        <div>
          <Title>{product.title}</Title>
          <Price>{getPrice()}</Price>
          <Link href={href}>Customize</Link>
        </div>
      </CardInnerContainer>
    </CardContainer>
  );
}

const CardContainer = styled.div`
  width: 100%;
  padding: 30px 20px;
  background: #ffffff;
`;
const CardInnerContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
`;
const ImageContainer = styled.div`
  display: flex;
  height: 250px;
  padding-bottom: 50px;
  justify-content: center;
  @media ${device.tablet} {
    height: auto;
  }
`;
const Image = styled.img`
  width: 80%;
  height: 100%;
  object-fit: cover;
`;
const Title = styled.h2`
  font-size: 18px;
  line-height: 20px;
  margin: unset;
  font-family: "sofia-pro";
`;
const Price = styled.div`
  font-size: 15px;
  margin-top: 1.2rem;
  padding-bottom: 12px;
  font-family: "sofia-pro";
`;
const Link = styled.a`
  color: #C20754;
  font-size: 18px;
  font-family: "sofia-pro";
  line-height: 20px;
  text-decoration: none;
  border-bottom: 1px solid #C20754;
`;
